const fields = {
    name: "name",
    code: "code",
    group: "type_post",
};

export function Position(positionData) {
    const { name, code, type_post, fixed_daily_salary } = positionData;
    return {
        name,
        code,
        group: type_post,
        fixed_daily_salary,
    };
}

export function formatPosition(positionData) {
    const params = {};

    Object.entries(fields).forEach(([key, fieldName]) => {
        if (key in positionData) {
            params[fieldName] = positionData[key];
        }
    });

    return params;
}
